import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lateRead: false,
    loginData: null,
    userData: {
      date_key: null,
      date: null,
      token: null,
      user_info: null,
      fever: '',
      cough: true,
      breath_difficult: true,
      runny_nose: true,
      headache: true,
      diarrtha: true,
      taste_disorder: true,
      postal_code: ''
    },
    resultData: null
  },
  mutations: {
    setLateRead (state, info) {
      state.lateRead = info
    },
    setLoginData (state, info) {
      state.loginData = info
      state.userData.user_info = info
    },
    setUserData (state, data) {
      state.userData = data
    },
    setResultData (state, resultData) {
      state.resultData = resultData
    }
  },
  actions: {
    setLateRead (context, info) {
      context.commit('setLateRead', info)
    },
    setLoginData (context, info) {
      context.commit('setLoginData', info)
    },
    setUserData (context, data) {
      context.commit('setUserData', data)
    },
    setResultData (context, resultData) {
      context.commit('setResultData', resultData)
    }
  },
  getters: {
    getLateRead (state) {
      return state.lateRead
    },
    getLoginData (state) {
      return state.loginData
    },
    getUserData (state) {
      return state.userData
    },
    getResultData (state) {
      return state.resultData
    }
  },
  modules: {
  }
})
